import React, { useState } from 'react';
import { Layout } from '../components/Layout';

export const Chat = () => {
  const [messages, setMessages] = useState([
    { id: 1, type: 'received', text: 'Halo, selamat datang!', time: '10:30' },
  ]);
  const [input, setInput] = useState('');

  const sendMessage = () => {
    if (!input.trim()) return;
    setMessages([...messages, { id: Date.now(), type: 'sent', text: input, time: new Date().toLocaleTimeString('id-ID', { hour: '2-digit', minute: '2-digit' }) }]);
    setInput('');
  };

  return (
    <Layout title="💬 Chat" subtitle="Customer Service">
      <div style={{ padding: '8px 16px', maxHeight: '60vh', overflow: 'auto' }}>
        {messages.map(msg => (
          <div key={msg.id} style={{
            maxWidth: '80%',
            padding: '10px 14px',
            borderRadius: '12px',
            marginBottom: '8px',
            background: msg.type === 'sent' ? 'var(--tg-blue)' : 'var(--tg-dark)',
            alignSelf: msg.type === 'sent' ? 'flex-end' : 'flex-start',
            marginLeft: msg.type === 'sent' ? 'auto' : '0',
          }}>
            {msg.text}
            <div style={{ fontSize: '10px', color: 'rgba(255,255,255,0.4)', marginTop: '4px' }}>{msg.time}</div>
          </div>
        ))}
      </div>
      <div style={{ padding: '8px 16px', display: 'flex', gap: '8px', position: 'sticky', bottom: '70px', background: 'var(--tg-bg)' }}>
        <input className="tg-input" placeholder="Ketik pesan..." value={input} onChange={(e) => setInput(e.target.value)} onKeyPress={(e) => e.key === 'Enter' && sendMessage()} />
        <button className="tg-btn tg-btn-primary" style={{ width: 'auto', padding: '8px 16px' }} onClick={sendMessage}>➤</button>
      </div>
      <div style={{ padding: '4px 16px', textAlign: 'center', fontSize: '11px', color: 'var(--tg-gray)' }}>
        ⚠️ Dilarang share No. HP, KTP, data pribadi!
      </div>
    </Layout>
  );
};
